import { types } from "../../types/types";
import { finishSpinner, startSpinner } from "../ui/spinner";
import AdiccionesService from "../../services/AdiccionesService";
import { handleErrorApi } from "../../helpers/randoms";
import { startAlerta } from "../ui/alertas";
import { TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";
import { ESTADO_SOLICITUD_ADICCIONES } from "../../components/adicciones/data/constants";

const baseUrl = process.env.REACT_APP_API_URL;

export const clearAdicciones = () => ({ type: types.adiccionesClearReducer });

export const setBreadcrumbCud = (data) => ({ type: types.adiccionesSetBreadcrumbCud, payload: data });

export const setActiveStepAdicciones = (step) => ({ type: types.adiccionesSetStep, payload: step });

export const setAfiliadoSeleccionadoAdicciones = (afiliado) => ({ type: types.adiccionesSetAfiliadoSeleccionado, payload: afiliado });
export const cleanAfiliadoSeleccionadoAdicciones = () => ({ type: types.adiccionesCleanAfiliadoSeleccionado });

export const setEfectorSeleccionadoDiscapacidad = (afiliado) => ({ type: types.adiccionesSetEfectorSeleccionado, payload: afiliado });
export const cleanEfectorSeleccionadoDiscapacidad = () => ({ type: types.adiccionesCleanEfectorSeleccionado });

export const cleanSolicitudesAdiccionesTomadas = () => {
  return { type: types.adiccionesSolicitudesTomadasLimpiar };
};

export const setEstadoSolicitudesAdicciones = (estado) => {
  return {
    type: types.adiccionesSetEstadoSolicitudes,
    payload: estado,
  };
};

export const cleanTipoDocumentacionAbmAdicciones = () => ({ type: types.adiccionesCleanTiposDocumentacionAbm });

export const cleanSolicitudAdicciones = () => ({ type: types.adiccionesCleanSolicitudes });

export const cleanSolicitudAdiccionesSeleccionada = () => ({ type: types.adiccionesCleanSolicitudSeleccionada });

export const setSolicitudAdicciones = (solicitud) => {
  return {
    type: types.adiccionesSetSolicitudSeleccionada,
    payload: solicitud,
  };
};

export const updateSolicitudAdicciones = (key, value) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().adicciones;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada };
      solicitudAux[key] = value;
      dispatch({
        type: types.adiccionesUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudAdiccionesValues = (values) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().adicciones;

    console.log("values", values);
    console.log("if", solicitudSeleccionada);

    //if (solicitudSeleccionada) { OJO CON ESTO POR LAS DUDAS
      const solicitudAux = { ...solicitudSeleccionada, ...values };
      dispatch({
        type: types.adiccionesUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    //}
  };
};

export const addPracticaAdicciones = (practica) => {
  return { type: types.adiccionesAddPractica, payload: practica };
};

export const deletePracticaAdicciones = (id) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().adicciones.solicitudSeleccionada;
    const practicasAux = practicas.filter(
      (practica) => practica.idCodNom !== id
    );
    dispatch({ type: types.adiccionesSetPracticas, payload: practicasAux });
  };
};

export const setearValorEnPracticaAdicciones = (idPractica, key, value) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().adicciones.solicitudSeleccionada;
    const practicasAux = [...practicas];
    const index = practicasAux.findIndex((p) => p.idCodNom === idPractica);
    if (index >= 0) {
      practicasAux[index][key] = value;
      dispatch({
        type: types.adiccionesSetPracticas,
        payload: practicasAux,
      });
    }
  };
};

export const getSolicitudesContadoresGestionAdicciones = (
  idAfiliado,
  idCodNom,
  idSolicitud,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  spinner = true
) => {
  return async (dispatch) => {    
    try {
      spinner&& dispatch(startSpinner());
      const cargarGrilla = idEstadoSolicitud ? true : false;
      await Promise.all([
        cargarGrilla 
          ? 
          AdiccionesService.getSolicitudesAuditoria(
              idAfiliado,
              idCodNom,
              idSolicitud,
              fechaDesde,
              fechaHasta,
              idEstadoSolicitud,
            )
          :
            null
        ,
        AdiccionesService.getContadoresSolicitudesAdicciones(
          idAfiliado,
          idCodNom,
          idSolicitud,
          fechaDesde,
          fechaHasta
        )
      ]).then(async([resultComprobantes, resultContadores]) => {      
        const bodyContadores = await resultContadores.json();  
        if (resultContadores.ok) {
          dispatch({
            type: types.adiccionesGetContadoresSolicitudesSuccess,
            payload: bodyContadores,
          });
        } else {
          throw bodyContadores;
        }
        const bodyComprobantes = cargarGrilla ? await resultComprobantes.json() : null;
        if (resultComprobantes?.ok) {
            dispatch({
              type: types.adiccionesGetSolicitudesSuccess,
              payload: bodyComprobantes,
            });
          } else {
            if(cargarGrilla){
              throw bodyComprobantes;
            }
          }          
      })    
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetSolicitudesError });
      dispatch({ type: types.adiccionesGetContadoresSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposSolicitudesAdicciones = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getTiposSolicitudes();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetTiposSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetTiposSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postSolicitudAdicciones = (
  data,
  nextStep = null,
  // getSolicitudesAuditoria = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = !!data?.idSolicitud
        ? await AdiccionesService.putSolicitud(data)
        : await AdiccionesService.postSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            !!data?.idSolicitud
              ? "Solicitud actualizada correctamente"
              : "Solicitud enviada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (!data.idSolicitud) {
          dispatch(updateSolicitudAdicciones("idSolicitud", body.idSolicitud));
          dispatch(updateSolicitudAdicciones("idTipoSolicitud", body.idTipoSolicitud));
          // dispatch(updateSolicitud("practicas", []));
        }
        if (nextStep) dispatch(setActiveStepAdicciones(nextStep));
        // if (getSolicitudesAuditoria){
        //   const { estadoSolicitudes } = getState().autorizaciones;
        //   dispatch(
        //     getSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
        //   );
        //   dispatch(
        //     getContadoresSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
        //   );
        // }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar solicitud"
          : "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putCancelarSolicitudAdicciones = (
  idSolicitud,
  closeModalAuditar,
  reloadSolicitudesAuditoria,
  // filtros
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.putCancelarSolicitud({ idSolicitud });
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Solicitud cancelada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (closeModalAuditar) closeModalAuditar();
        if (reloadSolicitudesAuditoria) {
          const { estadoSolicitudes } = getState().adicciones;
          dispatch(
            getSolicitudesContadoresGestionAdicciones(
              null,
              null,
              null,
              null,
              null,
              parseInt(estadoSolicitudes)
            )
          );
        }  
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al cancelar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPracticasAdicciones = (
  data,
  nextStep = null,
  enviarSolicitud,
  setRedirect
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.postPracticas(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateSolicitudAdicciones("practicas", body));
        dispatch({
          type: types.adiccionesGetPracticasSuccess,
          payload: body,
        });
        if (nextStep) dispatch(setActiveStepAdicciones(nextStep));
        if (enviarSolicitud) {
          dispatch(cambiarEstadoSolicitudAdicciones(
            {
              idSolicitud: data.idSolicitud,
              idEstadoSolicitud: ESTADO_SOLICITUD_ADICCIONES.PENDIENTE_AUTORIZACION
            },
            setRedirect
          )
          );
        }
        /* if (getSolicitudesAuditoria) {
          const { estadoSolicitudes } = getState().autorizaciones;
          dispatch(
            getSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
          dispatch(
            getContadoresSolicitudesAuditoria(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
        } */
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putPeriodosAdicciones = (
  data,
  closeModal) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.putPeriodos(data);
      const body = await result.json();      
      if (result.ok) {
        dispatch(
          startAlerta(
            "Periodos guardados exitosamente",
            "success",
            "Comando Exitoso"
          )
        );      
        dispatch(updateSolicitudAdicciones("periodos", body?.periodos));
        dispatch(updateSolicitudAdicciones("practicas", body?.practicas));
        closeModal&& closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar los periodos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const anularPeriodoAdicciones = (idSolicitud, periodo) =>{ 
  return async (dispatch) =>{
    try{
      dispatch(startSpinner())
      const result = await AdiccionesService.anularPeriodo(idSolicitud, periodo)
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitudAdicciones('periodos', body));
        dispatch(startAlerta("Se ha anulado el periodo.", "success"))
      } else {
        throw body;
      }
      dispatch(finishSpinner())
    }catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al anular el periodo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
};

export const cambiarEstadoSolicitudAdicciones = (data, setRedirect, getAuditoria, closeModal, setOpenAlert) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await AdiccionesService.putEstadoSolicitud(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      const MENSAJES = {
        2: 'Enviada',
        4: 'Enviada',
        5: 'Autorizada',
        6: 'Rechazada'
      }
      const msj = MENSAJES[data.idEstadoSolicitud]
      if (body.idEstadoSolicitud === ESTADO_SOLICITUD_ADICCIONES.AUTORIZADA && !body.emailEnviadoPrestador) {
        if (setOpenAlert) setOpenAlert(true);
      } else {
        dispatch(
          startAlerta(
            `Solicitud ${msj} Exitosamente`,
            "success",
            "Comando Exitoso"
          )
        );
        if (getAuditoria) {
          const { estadoSolicitudes } = getState().adicciones;
          dispatch(
            getSolicitudesContadoresGestionAdicciones(null, null, null, null, null, parseInt(estadoSolicitudes))
          );
        }
        if (setRedirect) setRedirect(true);
        if (!!closeModal) closeModal();
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//TRACKING SOLICITUD
export const getTrackingSolicitudAdicciones = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AdiccionesService.getTrackingSolicitudAdicciones(
        idSolicitud
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.adiccionesGetTrackingSolicitudSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.adiccionesGetTrackingSolicitudError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//PDF
export const generatePdfPorIdSolicitudAdicciones = (
  idSolicitud,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await AdiccionesService.generatePdfPorIdSolicitudAdicciones(
        idSolicitud,
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        window.open(URL.createObjectURL(blob));
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

//TIPO DOCUMENTACION
export const getAllTiposDocumentacionAdicciones = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getAllTiposDocumentacionAdicciones();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionAdicciones = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDoc 
        ? await AdiccionesService.putTipoDocumentacionAdicciones(data)
        : await AdiccionesService.postTipoDocumentacionAdicciones(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDoc 
            ? types.adiccionesPutTiposDocumentacion 
            : types.adiccionesPostTiposDocumentacion,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionAdicciones = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.deleteTipoDocumentacionAdicciones(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesDeleteTiposDocumentacion,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar tipo de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//TIPO DOCUMENTACION SOLICITUD
export const getTiposDocumentacionSolicitudAdicciones = (idTipoSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getTiposDocumentacionSolicitudAdicciones(idTipoSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getAllTiposDocumentacionSolicitudAdicciones = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getAllTiposDocumentacionSolicitudAdicciones();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetTiposDocumentacionSuccessAbm,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetTiposDocumentacionErrorAbm });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionSolicitudAdicciones = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDocSolicitud 
        ? await AdiccionesService.putTipoDocumentacionSolicitudAdicciones(data)
        : await AdiccionesService.postTipoDocumentacionSolicitudAdicciones(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDocSolicitud 
            ? types.adiccionesPutTiposDocumentacionAbm
            : types.adiccionesPostTiposDocumentacionAbm,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionSolicitudAdicciones = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.deleteTipoDocumentacionSolicitudAdicciones(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesDeleteTiposDocumentacionAbm,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


//DOCUMENTACION SOLICITUD
export const getDocumentacionSolicitudAdicciones = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getDocumentacionSolicitudAdicciones(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionSolicitudAdicciones = (idSolicitud, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.deleteDocumentacionSolicitudAdicciones(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionSolicitudAdicciones(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoSolicitudAdiccionesHandler = (idSolicitud, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoSolicitudAdicciones(formData, idSolicitud, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoSolicitudAdicciones = (formData, idSolicitud, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionSolicitudAdicciones/${idSolicitud}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionSolicitudAdicciones(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};


//SOLICITUDES TOMADAS
export const getSolicitudesAdiccionesTomadasPorUsuario = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result =
        await AdiccionesService.getSolicitudesTomadasPorUsuario();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesSolicitudesTomadasUsuarioSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.adiccionesSolicitudesTomadasUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas por Usuario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesAdiccionesTomadas = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getSolicitudesTomadas();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesSolicitudesTomadasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.adiccionesSolicitudesTomadasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putLiberarSolicitudAdicciones = (itemTomado, userType, fromHomeScreen, setOpenAlert, item, 
  setOpenModalAuditar, closeModal, reload, filtros) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.putLiberarSolicitud(itemTomado.id);
      const body = await result.json();
      if (result.ok) {        
        if (userType === "currentUser") {
          dispatch({
            type: types.adiccionesSolicitudesTomadasUsuarioLiberar,
            payload: itemTomado.id,
          });          
          dispatch({
            type: types.adiccionesSolicitudesDesmarcarLiberada,
            payload: { idSolicitud: itemTomado.idSolicitud },
          });
          if (fromHomeScreen) {
            setOpenAlert(false);
            dispatch(postTomarSolicitudAdicciones(item, setOpenModalAuditar))
          }
          if (reload){
            const { estadoComprobantes } = getState().adicciones;
            dispatch(
              getSolicitudesContadoresGestionAdicciones(
                filtros?.idAfiliado, 
                filtros?.idCodNom,
                filtros?.idSolicitud,
                filtros?.fechaDesde, 
                filtros?.fechaHasta,
                parseInt(estadoComprobantes)),
                false
            );
          }
          if (!!closeModal) closeModal();
        }
        else if (userType === "allUsers")
          dispatch({
            type: types.adiccionesSolicitudesTomadasLiberar,
            payload: itemTomado.id,
          });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTomarSolicitudAdicciones = (solicitud, setOpenModalAuditar) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.postTomarSolicitud(
        solicitud.idSolicitud
      );
      const body = await result.json();
      if (result.ok) {
        if (body.idSolicitud !== 0) {
          dispatch({
            type: types.adiccionesSolicitudesTomadasUsuarioAgregar,
            payload: body,
          });
          dispatch({
            type: types.adiccionesSolicitudesMarcarTomada,
            payload: { solicitud, auth: getState().auth, id: body.id },
          });
          setOpenModalAuditar(true);
          const nuevoItem = {
            ...solicitud, 
            solicitudesTomadas: solicitud.solicitudesTomadas.length > 0
              ? solicitud.solicitudesTomadas
              : [{...body}]
          }
          dispatch(setSolicitudAdicciones(nuevoItem));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//NOTAS SOLICITUD
export const getNotasPorSolicitudAdicciones = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AdiccionesService.getNotas(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.adiccionesGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.adiccionesGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const postNotasAdicciones = (data, idSolicitud, method, closeModalHandler, continuarConDevolucion,
  idEstadoSolicitud, closeModalAuditar) => {
  return async (dispatch) => {
    try {
      
      dispatch(startSpinner());
      const result = await AdiccionesService.postNota(data, method);
      const body = await result.json();
      if (result.ok) {
        if (idEstadoSolicitud) {
          dispatch(cambiarEstadoSolicitudAdicciones({
            idSolicitud: idSolicitud,
            idEstadoSolicitud: idEstadoSolicitud
          }, null,null,closeModalAuditar));
          
        } else {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(getNotasPorSolicitudAdicciones(idSolicitud));
        }
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteNotaAdicciones = (idNota, idSolicitud, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.deleteNota({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorSolicitudAdicciones(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getConsumosAfiliadosAdicciones = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AdiccionesService.getConsumosAfiliados(idAfiliado);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.adiccionesGetConsumosAfiliadosSuccess,
        payload: body,
      });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer los consumos.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

/*********************************************************************************************************************************/
//ESTO NO IRIA MAS

export const updateSolicitudDiscapacidadTerapia = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().adicciones;

    if (solicitudSeleccionada?.integracionTerapia) {
      const newTerapia = solicitudSeleccionada?.integracionTerapia;
      newTerapia[key] = value;

      dispatch({
        type: types.discapacidadUpdateTerapiaSolicitudSeleccionada,
        payload: newTerapia,
      });
    }
  };
};

export const updateSolicitudDiscapacidadTransporte = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().adicciones;

    if (solicitudSeleccionada?.integracionTransporte) {
      const newTransporte = solicitudSeleccionada?.integracionTransporte;
      newTransporte[key] = value;

      dispatch({
        type: types.discapacidadUpdateTransporteSolicitudSeleccionada,
        payload: newTransporte,
      });
    }
  };
};

export const getTiposPrestacionesDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getTiposPrestaciones();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposPrestacionesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposPrestacionesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de prestaciones",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSubTiposSolicitudesDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getSubTipoSolicitudes();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetSubTiposSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetSubTiposSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposTransporteDiscapacidad = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getTiposTransporteDiscapacidad();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetTiposTransportesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.discapacidadGetTiposTransportesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de transporte",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getAllTiposDocumentacionAfiliadoIntegracion = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.getAllTiposDocumentacionAfiliadoIntegracion();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesGetTiposDocumentacionSuccessAbm,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.adiccionesGetTiposDocumentacionErrorAbm });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const guardarTipoDocumentacionAfiliadoIntegracion = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = data.idTipoDocAfiliado 
        ? await AdiccionesService.putTipoDocumentacionAfiliadoIntegracion(data)
        : await AdiccionesService.postTipoDocumentacionAfiliadoIntegracion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: data.idTipoDocAfiliado 
            ? types.adiccionesPutTiposDocumentacionAbm
            : types.adiccionesPostTiposDocumentacionAbm,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar tipo de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTipoDocumentacionAfiliadoIntegracion = (id, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AdiccionesService.deleteTipoDocumentacionAfiliadoIntegracion(id);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.adiccionesDeleteTiposDocumentacionAbm,
          payload: id,
        });
        dispatch(
          startAlerta(
            "Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        if(handleClose) handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getFormularioCud = (idAfiliado, notShowMsj = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      // dispatch(certificadosTraerStart());
      const result = await AdiccionesService.getFormularioCud(idAfiliado);
      if (result.status === 204) {
        dispatch({
          type: types.discapacidadSetFormularioCudSuccess,
          payload: null,
        });
      } else {
        const body = await result.json();
        if (result.ok) {
          dispatch({
            type: types.discapacidadSetFormularioCudSuccess,
            payload: body,
          });
          if (!notShowMsj) {
            dispatch(
              startAlerta(
                "Formulario cargado correctamente",
                "success",
                "Comando Exitoso"
              )
            );
          }
        } else {
          throw body;
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al cargado el formulario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
}


export const postFormularioCud = (
  data,
  existe
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = existe
        ? await AdiccionesService.putFormularioCud(data)
        : await AdiccionesService.postFormularioCud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadSetFormularioCudSuccess,
          payload: body,
        });
        dispatch(
          startAlerta(
            existe
              ? "Formulario actualizado correctamente"
              : "Formulario generado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        existe
          ? "Error al actualizar el formulario"
          : "Error al generar el formulario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};